$(".question").on("click", function () {
  const currentMobile = $(this)
    .children()
    .first()
    .children()
    .last()
    .children()
    .first();

  $(this).children().last().slideToggle(300);
  $(this).toggleClass("active");
  currentMobile.toggleClass("active");

  if (currentMobile.hasClass("active")) {
    currentMobile.html("Скрыть ответ");
  } else {
    currentMobile.html("Показать ответ");
  }
});
